import { cuandoCita } from '../lib/tiempo'

export type CitaEnAgenda = { fecha: string; hora: string } | { ausente: true } | null

/** Debajo de la fecha que dijo el hilo. Si coinciden, no se pinta (spec 078). */
export function AvisoCitaAgenda({ cita }: { cita: CitaEnAgenda | undefined }) {
    if (!cita) return null
    const texto =
        'ausente' in cita
            ? 'Ya no está en la agenda. Posiblemente se haya quitado a mano.'
            : `En la agenda figura ${cuandoCita(cita.fecha, cita.hora)}. Posiblemente se haya modificado a mano.`
    return <p className="mt-1 text-amber-100/90">{texto}</p>
}
